import { Component, h } from '@stencil/core';

@Component({
  tag: 'icon-chevron-up',
  shadow: true,
})
export class IconChevronUp {
  render() {
    return (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="20" height="20" rx="10" fill="white" />
        <path
          d="M10.1837 8.84522L5.6723 13.4871C5.31144 13.8584 4.71791 13.8669 4.34661 13.506C3.97531 13.1452 3.96684 12.5516 4.3277 12.1803L9.51145 6.8466C9.87964 6.46776 10.488 6.46779 10.8561 6.84668L16.0386 12.1804C16.3994 12.5518 16.3909 13.1453 16.0196 13.5061C15.6482 13.8669 15.0547 13.8584 14.6939 13.4871L10.1837 8.84522Z"
          fill="#0579C7"
        />
        <mask id="mask0_4_118" maskUnits="userSpaceOnUse" x="4" y="6" width="13" height="8">
          <path
            d="M10.1837 8.84522L5.6723 13.4871C5.31144 13.8584 4.71791 13.8669 4.34661 13.506C3.97531 13.1452 3.96684 12.5516 4.3277 12.1803L9.51145 6.8466C9.87964 6.46776 10.488 6.46779 10.8561 6.84668L16.0386 12.1804C16.3994 12.5518 16.3909 13.1453 16.0196 13.5061C15.6482 13.8669 15.0547 13.8584 14.6939 13.4871L10.1837 8.84522Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_4_118)">
          <rect width="20" height="20" fill="#0579C7" />
        </g>
      </svg>
    );
  }
}
